import { useEffect, useState } from "react";
import RotatePhoneSVG from "../../../public/assets/svg/RotatePhone";
import rotateIcon from "../../../public/assets/svg/rotate-icon.svg";
import "../stylesheets/rotateDevice.scss";
import Image from "next/image";

export default function RotateDevice() {
  const [isMobileLandscape, setIsMobileLandscape] = useState(false);

  const checkOrientation = () => {
    if (window.innerWidth <= 932 && window.innerHeight <= 430) {
      setIsMobileLandscape(true);
      document.body.style.maxHeight = "100vh";
    } else {
      setIsMobileLandscape(false);
      document.body.style.maxHeight = "unset";
    }
  };

  useEffect(() => {
    checkOrientation();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      checkOrientation();
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // show only when in landscape mode on mobile
  if (!isMobileLandscape) return null;

  return (
    <div className="rotate-device-overlay">
      <div className="rotate-device-content">
        <div className="phone-animation">
          <RotatePhoneSVG />
          <Image
            src={rotateIcon}
            alt=""
            role="presentation"
            className="rotate-arrows"
          />{" "}
        </div>
        <h2 className="rotate-device-text">
          Please rotate your device to portrait <br /> Or resize your browser
          window.
        </h2>
      </div>
    </div>
  );
}
